import BreadCrumb from "Components/Common/BreadCrumb";
import SectionsTable from "Components/Settings/Sections/SectionsTable";
import React from "react";
import { Container } from "reactstrap";

const Sections = () => {
  document.title = "Sections | EaziQuote";
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Sections" pageTitle="Settings" url="/settings" />

        <SectionsTable />
      </Container>
    </div>
  );
};

export default Sections;
